import { Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Testimonials() {
  const { t } = useLang();
  const testimonials = [
    { quoteKey: "testimonials.t1.quote", name: "Priya S.", roleKey: "testimonials.t1.role", initials: "PS", color: "bg-brand" },
    { quoteKey: "testimonials.t2.quote", name: "Marcus L.", roleKey: "testimonials.t2.role", initials: "ML", color: "bg-zinc-900" },
    { quoteKey: "testimonials.t3.quote", name: "Alessia G.", roleKey: "testimonials.t3.role", initials: "AG", color: "bg-emerald-600" },
  ];
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-10 py-16" data-testid="testimonials-section">
      <div className="grid md:grid-cols-12 gap-10 items-end mb-10">
        <div className="md:col-span-6">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand">{t("testimonials.badge")}</div>
          <h2 className="mt-2 font-display font-bold text-3xl sm:text-4xl tracking-tight text-zinc-900">
            {t("testimonials.title")}
          </h2>
        </div>
        <div className="md:col-span-6">
          <p className="text-zinc-600 max-w-lg">
            {t("testimonials.subtitle")}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((item, i) => (
          <figure
            key={item.name}
            className="bg-white rounded-3xl border border-zinc-100 p-8 flex flex-col animate-fade-up"
            style={{ animationDelay: `${i * 100}ms` }}
            data-testid={`testimonial-${i}`}
          >
            <div className="flex items-center gap-0.5 text-brand mb-4">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" />)}
            </div>
            <blockquote className="font-display text-lg text-zinc-900 leading-snug tracking-tight flex-1">
              &ldquo;{t(item.quoteKey)}&rdquo;
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3 pt-6 border-t border-zinc-100">
              <div className={`w-10 h-10 rounded-full ${item.color} text-white flex items-center justify-center font-display font-bold text-sm`}>
                {item.initials}
              </div>
              <div>
                <div className="text-sm font-semibold text-zinc-900">{item.name}</div>
                <div className="text-xs text-zinc-500">{t(item.roleKey)}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
